import styled from '@emotion/styled'
import tw from 'twin.macro'

export const AvatarWithTextWrapper = styled.div`
  ${tw`
    flex-shrink-0
  `}
  div {
    ${tw`
      flex
      items-center
    `}
  }
`

export const AvatarWithTextImage = styled.div`
  img {
    ${tw`
      inline-block
      object-cover
      h-9
      w-9
      md:h-12
      md:w-12
      rounded-full
      bg-white
      shadow-2xl
      mr-3
      md:mr-6
    `}
  }
`

export const AvatarWithTextInfo = styled.div`
  ${tw`
    flex
    flex-wrap
  `}
  .name {
    ${tw`
      text-sm
      md:text-lg
      leading-5
      font-bold
      text-purple-300
      hover:text-purple-800
      cursor-pointer
      w-full
    `}
  }
  .job {
    ${tw`
      text-xs
      md:text-sm
      leading-4
      font-medium
      text-purple-300
      w-full
    `}
  }
`
